module.exports = __webpack_public_path__ + "fonts/THICCCBOI-SemiBold.2db53914.woff";